import { useState } from "react";

export default function ImagePreview({ url, thumbnail }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* 点击缩略图 */}
      <img
        src={thumbnail}
        style={{
          width: 260,
          borderRadius: "10px",
          cursor: "zoom-in",
        }}
        onClick={() => setOpen(true)}
      />

      {/* 弹窗 */}
      {open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={() => setOpen(false)}
        >
          <img
            src={url}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "10px",
            }}
            onClick={(e) => e.stopPropagation()} // 防止点图片关闭
          />
        </div>
      )}
    </>
  );
}
